import { authenticatedApiCall } from '../authenticatedApiCall'

export const postAiAssistantAccess = async (access) => {
  const response = await authenticatedApiCall({
    method: 'post',
    url: '/v6/user/mark/',
    data: { data: access }
  })

  if (response.data.status !== 'ok') {
    throw new Error(response.data.message)
  } else {
    return response.data.data
  }
}
